module.exports = __webpack_public_path__ + "media/images/hero-2025-3f0eb83afa3164b8a115c41a8ea09314.jpg";